<template>
	<div>
		<div class="flex flex-row gap-6 justify-center pb-6 pt-4">
			<div class="rounded-full px-2 font-bold" :style="getStepStyling(1 - 1)">
				1
			</div>
			<div>
				---
			</div>
			<div v-if="onBoardingStep !== 1" class="flex flex-row">
				<div class="rounded-full px-2 font-bold" style="background-color: lightgrey; font-size: 14px; width: 25px; padding-left: 5px">
					...
				</div>
				<div class="pl-6">
					---
				</div>
			</div>
			<div v-if="onBoardingStep !== filteredSteps && onBoardingStep !== 0 && onBoardingStep !== filteredSteps - 1" class="flex flex-row">
				<div class="rounded-full px-2 font-bold" :style="getStepStyling(onBoardingStep)">
					{{ onBoardingStep + 1 }}
				</div>
				<div class="pl-6">
					---
				</div>
			</div>
			<div v-if="onBoardingStep !== 0 && onBoardingStep !== filteredSteps - 1 && onBoardingStep !== filteredSteps - 2" class="flex flex-row">
				<div class="rounded-full px-2 font-bold" style="background-color: lightgrey; font-size: 14px; width: 25px; padding-left: 5px">
					...
				</div>
				<div class="pl-6">
					---
				</div>
			</div>
			<div class="rounded-full px-2 font-bold" :style="getStepStyling(filteredSteps - 1)">
				{{ filteredSteps }}
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'OnboardingStepWidget',
	props: {
		onBoardingStep: { default: 0, required: true },
		filteredSteps: { default: 0, required: true },
	},
	methods: {
		getStepStyling(step) {
			let styling = '';
			if (this.onBoardingStep === step) {
				styling += 'background-color: #3c81df; color: #ffffff; ';
			} else {
				styling += 'background-color: lightgrey; ';
			}
			if (step > 8) {
				styling += 'font-size: 14px; width: 25px; padding-left: 5px';
			} else {
				styling += 'font-size: 15px';
			}

			return styling;
		},
	},
};
</script>
